import { useQuery } from '@tanstack/react-query';
import {
  BidvVirtualAccountService,
  InquiryBidvVAEntity,
} from 'services/openapi';
import { BidvVAInquiryParams } from '../types';

import { BidvVirtualAccountServiceQueryKeys } from '../constants';

type InquiryBidvVAQueryDTO = BidvVAInquiryParams & {
  enabled?: boolean;
  requestId?: number;
};

export const useInquiryBidvVAQuery = (variables: InquiryBidvVAQueryDTO) => {
  const {
    vaPrefix,
    endCode,
    startDate,
    endDate,
    enabled = true,
    requestId = 0,
  } = variables;
  const queryKey = [
    BidvVirtualAccountServiceQueryKeys.INQUIRY,
    vaPrefix,
    endCode,
    startDate,
    endDate,
    requestId,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<InquiryBidvVAEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvVirtualAccountService.bidvVaControllerInquiry(
        vaPrefix,
        endCode,
        startDate,
        endDate,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled: enabled && !!vaPrefix && !!endCode,
  });

  return {
    isLoading,
    error,
    data: data?.data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};
